import React from 'react';
import { Link } from 'react-router-dom';
import LogoBlanc from '../media/logo_RAVAIL_horizontal_blanc.webp';
import './FooterVitrine.css';

function FooterVitrine({ waveBackground = '#ffffff' }) {
  const year = new Date().getFullYear();

  return (
    <>
      <div className="fv-wave" style={{ background: waveBackground }} aria-hidden="true">
        <svg viewBox="0 0 1280 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 120 H1280 V60 C1000 0 300 120 0 40 Z" fill="#3a5886"/>
        </svg>
      </div>
      <footer className="footer-vitrine">
      <div className="fv-content">
        <nav className="fv-nav">
          <Link to="/" aria-label="Accueil RAVAIL">
            <img src={LogoBlanc} alt="RAVAIL" className="fv-logo" />
          </Link>
          <div className="fv-col">
            <span className="fv-col-title">Où nous trouver</span>
            <Link to="/qui-sommes-nous" className="fv-link">Qui sommes-nous</Link>
            <Link to="/contact" className="fv-link">Nous contacter</Link>
          </div>
          <div className="fv-col">
            <span className="fv-col-title">Notre solution</span>
            <Link to="/notre-solution" className="fv-link">Fonctionnalités</Link>
            <Link to="/notre-solution#securite" className="fv-link">Sécurité des données</Link>
            <Link to="/#faq" className="fv-link">FAQ</Link>
          </div>
          <div className="fv-col">
            <span className="fv-col-title">Informations légales</span>
            <Link to="/mentions-legales" className="fv-link">Mentions légales</Link>
            <Link to="/cgu" className="fv-link">Conditions générales d'utilisation</Link>
            <Link to="/politique-de-confidentialite" className="fv-link">Politique de confidentialité</Link>
          </div>
          <div className="fv-col">
            <span className="fv-col-title">Médias</span>
            <Link to="/blog" className="fv-link">Blog</Link>
            <a href="https://www.linkedin.com/company/ravail" target="_blank" rel="noopener noreferrer" className="fv-link">LinkedIn</a>
          </div>
        </nav>
      </div>
      <p className="fv-copyright">RAVAIL - Travail Santé - &copy;2023-{year} Tous droits réservés</p>
      </footer>
    </>
  );
}

export default FooterVitrine;
